// eslint-disable-next-line import/prefer-default-export
export const PROVIDERS_LIST = [
    { label: '1T', value: '1t' },
    { label: 'Росноу', value: 'rosnou' },
    { label: 'Финка', value: 'fin' },
    { label: 'Обрсоюз', value: 'obr' },
    { label: 'Тест', value: 'test' },
];
